import { FaSolidKeyboard } from "solid-icons/fa"
import { createMemo, Show, type Accessor, type Component } from "solid-js"
import isMac from "../../ldsh/isMac"
import { InputActionType } from "./InputActionType"
import { type KeyboardInputBinding } from "./InputBinding/KeyboardInputBinding.type"
import { InputBindingDevice } from "./InputBindingDevice.enum"
import { actionBindings } from "./actionBindings"

interface Props {
  icon?: boolean
  action: InputActionType
}

const modKeyLabels = {
  ctrl: isMac ? "⌘" : "Ctrl",
  alt: isMac ? "⌥" : "Alt",
  shift: "Shift",
}
const KeyboardShortcut: Component<Props> = (props) => {
  const keyboardBinding = createMemo<KeyboardInputBinding | undefined>(() => {
    return actionBindings.find(ab => {
      return ab.action === props.action && ab.input.device === InputBindingDevice.Keyboard
    })?.input as KeyboardInputBinding | undefined
  })

  return <Show when={keyboardBinding()} children={(keyboardBinding: Accessor<KeyboardInputBinding>) => {

    const text = createMemo(() => {
      const parts: string[] = []
      const kb = keyboardBinding()
      if (kb.ctrl) parts.push(modKeyLabels.ctrl)
      if (kb.alt) parts.push(modKeyLabels.alt)
      if (kb.shift) parts.push(modKeyLabels.shift)
      parts.push(formatKeyLabel(kb.code))
      return parts.join(" + ")
    })

    return <span class="keyboard-shortcut" title={text()}>
      {props.icon ? <FaSolidKeyboard /> : text()}
    </span>
  }} />
}

function formatKeyLabel(code: string): string {
  // Convert "KeyA" to "A", "ArrowLeft" to "←", etc.
  if (code.startsWith("Key")) return code.slice(3).toUpperCase()
  if (code.startsWith("Digit")) return code.slice(5)
  if (code.startsWith("Arrow")) {
    switch (code) {
      case "ArrowLeft": return "←"
      case "ArrowRight": return "→"
      case "ArrowUp": return "↑"
      case "ArrowDown": return "↓"
    }
  }
  // if (code === "Space") return "Space"
  // if (code === "Enter") return "Enter"
  return code // fallback
}

export default KeyboardShortcut